import React, { useContext, useMemo, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
// import { toast } from "react-toastify";

import useInvoice from "../../../hooks/useInvoice";
import { useGetBillingInfoQuery } from "../../../services/paymentService";
// import { useLazyGetVoucherValidityQuery } from "../../../services/orderService";
import { OrderContext } from "../../../providers/OrderProvider";
// import parseError from "../../../utils/errorUtils";

import Collapsible from "../../../components/collapsible/Collapsible";
import GoBack from "../../../components/GoBack";
import PrescriptionSummary from "../../../components/prescriptionSummary/PrescriptionSummary";
import { PrescriptionCheckoutForm } from "./orderDetails/PrescriptionCheckoutForm";
import Price from "../../../components/price/Price";
// import { Form, SubmitButton, TextField } from "../../../components/forms";
import { toast } from "react-toastify";
import parseError from "../../../utils/errorUtils";
import { useCreateCheckoutSessionMedicationMutation } from "../../../services/orderService";
import { AppointmentCheckoutFormFooter } from "../../appointment/AppointmentCheckoutForm";
import { useLoggerUtils } from "../../../utils/loggerUtils";
import { Form } from "../../../components/forms";
import { AppointmentContext } from "../../../providers/AppointmentProvider";
import { useGetMyProfileQuery } from "../../../services/userService";
import { useAuth } from "../../../utils/authUtils";

const fonts = [
    {
        cssSrc: "https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;600&display=swap",
        family: "Titillium Web",
    },
];

function OrderPaymentsPage() {
    const auth = useAuth();
    const { order, prescription, onPayPrescription, deliveryType } =
        useContext(OrderContext);

    // const [discount, setDiscount] = useState(null);
    const [initialValues, setInitialValues] = useState({
        name: "",
        terms_and_conditions: false,
        consent: false,
    });

    const medicationTotal = useInvoice("PRESCRIPTION_DRUG", "PRESCRIPTION");

    const { data: billingInfo } = useGetBillingInfoQuery();
    const { info } = useLoggerUtils();
    const [createCheckoutSessionMedication] = useCreateCheckoutSessionMedicationMutation();
    const { appointmentData, setAppointmentData } =
        useContext(AppointmentContext);
    const { data: profileData } =
        useGetMyProfileQuery({}, { skip: !auth.isLogged });
    // const [getVoucherValidity] = useLazyGetVoucherValidityQuery();

    // const handleCheckVoucherValidity = async (values) => {
    //     try {
    //         const res = await getVoucherValidity({ voucherId: values.voucher });

    //         if (res.error) {
    //             // handle error
    //             toast.error(
    //                 parseError(res.error, "couldn't submit voucher code")
    //             );
    //         } else {
    //             // handle success
    //             if (res.data.valid) {
    //                 const finalValue =
    //                     medicationTotal?.price * res.data.percentage;

    //                 setDiscount(finalValue);
    //             }
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };

    // delivery fee
    const deliveryFee = deliveryType === "EXPRESS" ? 15 : 0;

    useState(() => {
        if (order) {
            setInitialValues({
                ...initialValues,
                name: order.patient.displayName,
            });
        }
    }, [order]);

    const stripePromise = useMemo(async () => {
        if (billingInfo) {
            return await loadStripe(billingInfo.publicKey);
        }

        return null;
    }, [billingInfo]);

    const medicationPrice = useMemo(() => {
        // if (discount > 0) {
        //     return medicationTotal?.price - discount;
        // }

        return medicationTotal?.price;
    }, [
        medicationTotal,
        // discount
    ]);

    const handlePaymentDetailsProcess = async () => {
        const finalUrl = window.location.protocol + "//" + window.location.host + `/order/${order.id}/success`;
        try {
            let data = {
                quantity: 1,
                customerId: order?.patient.id.toString(),
                successUrl: finalUrl,
                cancelUrl: window.location.href,
                orderItemId: order?.id.toString(),
                description: order.type,
                paymentMode: profileData?.stripeSubscriptionId ? "SUBSCRIPTION" : "PAYMENT",
            };
            const res = await createCheckoutSessionMedication({
                values: data,
            });

            if (res.error) {
                toast.error(parseError(res.error, "Stripe Checkout Error!"));
            } else {
                setAppointmentData({});
                if (res?.data?.sessionId) {
                    localStorage.setItem("sessionId", res.data.sessionId);
                }
                window.location.replace(res?.data?.url);
            }
        } catch (e) {
            info("payPrescription - catch: " + JSON.stringify(e));
            console.error(e);
        }
    }

    return (
        <Elements stripe={stripePromise} options={{ fonts }}>
            <div className="row mx-0 h-100">
                <div className="col-md-6 pt-5 position-relative bg-light-gray">
                    <div className="row mx-0 mb-0 mb-md-8">
                        <div className="col-12 col-lg-11 col-xl-9 col-xxl-8 mx-auto pb-5 pb-md-0 mb-0 mb-md-8">
                            <GoBack />
                            <div className="col-12 col-lg-12 col-xl-12 col-xxl-12 py-4 px-4 pb-4 pb-md-3 mb-0 mb-md-1 mt-4 bg-gray-card border-custom rounded">
                                <Collapsible title="Order Summary" expanded>
                                    {prescription?.medication?.map((medicine) => (
                                        <div
                                            key={medicine.formulary.id}
                                            className="d-flex align-content-center"
                                        >
                                            <div>
                                                <img
                                                    className="last-order-img"
                                                    src={medicine.imageUrl}
                                                    alt={medicine.imageUrl}
                                                />
                                            </div>

                                            <label className="align-content-center ms-3 medicine-text">
                                                {medicine.formulary.productName}
                                            </label>
                                        </div>
                                    ))}
                                </Collapsible>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 pt-5 px-2 px-lg-6 mb-5 bg-white">
                    <div className="row mx-0 mb-8 mb-md-0 pb-8 pb-md-0">
                        <div className="col-12 col-lg-11 col-xl-9 col-xxl-10 mx-auto pb-5 pb-md-0 mb-0 mb-md-8">
                            <>
                                <div className="new-order-heading px-0">
                                    Payment details
                                </div>
                                <div className="ps-0 last-order-subheading w-100">
                                    Your payment will not be charged until your prescription is approved.
                                </div>
                            </>
                            <div className="mt-5 py-4 px-4 pb-4 pb-md-3 mb-0 mb-md-5 mt-4 bg-gray-card border-custom rounded">
                                <Collapsible title="Payment Summary" expanded>
                                    <div>
                                        <div className="d-flex mb-3 align-items-center justify-content-between text-medium-gray fs-6">
                                            <div>Medication total</div>
                                            <div>
                                                <Price
                                                    amount={medicationPrice}
                                                    currency="GBP"
                                                />
                                            </div>
                                        </div>
                                        <div className="d-flex mb-3 align-items-center justify-content-between text-medium-gray fs-6">
                                            <div>
                                                {deliveryType === "EXPRESS"
                                                    ? "Express delivery"
                                                    : "Shipping"}
                                            </div>
                                            <div>
                                                <Price
                                                    amount={Number(deliveryFee)}
                                                    currency="GBP"
                                                />
                                            </div>
                                        </div>

                                        <hr />
                                        <div className="d-flex mb-3 align-items-center fw-bold justify-content-between text-primary fs-5">
                                            <div>Total</div>
                                            <div>
                                                <Price
                                                    amount={
                                                        Number(
                                                            medicationPrice || 0
                                                        ) +
                                                        Number(deliveryFee || 0)
                                                    }
                                                    currency="GBP"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Collapsible>
                            </div>
                            <div className="col-12 col-lg-12 col-xl-11 col-xxl-8 px-0 w-100">
                                <Form
                                    initialValues={{
                                        terms_and_conditions: "",
                                    }}
                                    onSubmit={handlePaymentDetailsProcess}
                                >
                                    <AppointmentCheckoutFormFooter
                                        orderType={order.type}
                                        buttonText="Confirm Payment"
                                    />
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Elements>
    );
}

export default OrderPaymentsPage;
